// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"127":"32c39add","455":"eba78ce0","482":"b0f4d80a","544":"856309f4","550":"574b697e","708":"4538e19e"}[chunkId] + ".chunk.js";
};